import * as notify from "../../../../shared/notify";
import { get, post } from "../../../../shared/data";

export const getPicklistData = (param) => {
    return get(`/picklists/${param.type}?contains=${param.name}&isDesc=${param.isDesc}&isInactiveIncluded=true`);
};

export const archivePicklistItem = (param) => {
    return post(`/picklists/${param.type}`, param, { noRedirect: true }).then((response) => {
        if (!response) {
            notify.error("Archive failed!");

            return;
        }

        if (typeof response.text === "object") {
            notify.error(response.text);

            return;
        }

        return response;
    });
};

export const addPicklistItem = (param, settings) => {
    return post(`/picklists/${param.type}`, param, settings).then((response) => {
        if (!response) {
            notify.error("Adding new item failed!");

            return;
        }

        if (typeof response.text === "object") {
            notify.error(response.text);

            return;
        }

        return response;
    });
};
